<script setup>
import ServiceListItem from '@/components/shared/ServiceListItem.vue'
import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  options: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: null,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  useInput: {
    type: Boolean,
    default: false,
  },
  inputDebounce: {
    type: [Number, String],
    default: null,
  },
})

const emit = defineEmits(['update:modelValue', 'filter'])

const onFilter = (...args) => emit('filter', ...args)
</script>

<template>
  <q-select
    v-bind="$attrs"
    :model-value="modelValue"
    :options="options"
    :label="label"
    option-value="id"
    option-label="name"
    emit-value
    map-options
    :clearable="clearable"
    :disable="disable"
    :use-input="useInput"
    :input-debounce="inputDebounce ?? webSiteStore.getInputDebounce()"
    popup-content-class="service-selector-menu"
    @filter="onFilter"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #option="{ itemProps, opt }">
      <service-list-item
        v-bind="itemProps"
        :service="opt"
        clickable
        dense
      />
    </template>
  </q-select>
</template>
